// src/components/alert/HintSelectSensor.tsx

import { Alert } from '@mui/material'

export const HintSelectSensor = () => (
  <Alert severity={'warning'} sx={{ mx: 1, mb: 1 }}>
    Wählen Sie mindestens einen Sensor aus, um fortzufahren.
  </Alert>
)
